import { SearchActionType } from '@modules/feed/store/searchActionType';
import { useSearchStore } from '@modules/feed/store/searchStore';
import {
  AssistanceResponseThumbDownButton,
  AssistanceResponseThumbDownButtonProps,
} from '@modules/oracle/components/AssistanceResponseThumbDownButton/AssistanceResponseThumbDownButton';
import { useFlagFeedbackSummary } from '@modules/oracle/hooks';

interface FeedbackSummaryThumbDownButtonProps {
  responseID?: string;
}

export function FeedbackSummaryThumbDownButton({
  responseID,
}: FeedbackSummaryThumbDownButtonProps) {
  const dispatch = useSearchStore(({ dispatch }) => dispatch);
  const dislikeSet = useSearchStore(({ visual }) => visual.dislikeSet);
  const [flagFeedbackSummary] = useFlagFeedbackSummary();

  if (!responseID) {
    return null;
  }

  const isDisliked = dislikeSet.has(responseID);

  const onFeedbackSubmit: AssistanceResponseThumbDownButtonProps['onFeedbackSubmit'] =
    async (params) => {
      await flagFeedbackSummary(params);

      dispatch({
        type: SearchActionType.SET_VISUAL,
        payload: {
          dislikeSet: new Set([...dislikeSet, responseID]),
        },
      });
    };

  return (
    <AssistanceResponseThumbDownButton
      responseID={responseID}
      onFeedbackSubmit={onFeedbackSubmit}
      disabled={isDisliked}
      sx={{ color: 'text.secondary' }}
      userFeedbackOptions={[
        'Summary took a long time to load.',
        'I am not happy with the quality of the summary.',
      ]}
    />
  );
}
